/// \file fleetAsset.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const FleetAssetList = lazy(() => import('../views/fleet-asset/list/view'));

async function fleetAssetDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/fleet-asset/list/loader')).default;
  return actualLoader(args);
}

export async function fleetAssetAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/fleet-asset/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="asset/:id"
    handle={{
      text: 'inherit'
      }}
  >
    <Route 
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <FleetAssetList />
        </Suspense>
      }     
      loader={fleetAssetDataLoader}
      action={fleetAssetAction}
      />
  </Route>
);

export default routes;